"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_TITLE_COLOR = void 0;
/**
 * 타이틀 텍스트 색상
 */
var EN_TITLE_COLOR;
(function (EN_TITLE_COLOR) {
    EN_TITLE_COLOR["PINK"] = "pink";
    EN_TITLE_COLOR["DEFAULT"] = "default";
    EN_TITLE_COLOR["BLACK"] = "black";
    EN_TITLE_COLOR["AQUA_GREEN"] = "aqua_green";
    EN_TITLE_COLOR["DARK_GREEN"] = "dark_green";
    EN_TITLE_COLOR["GRAY"] = "gray";
    EN_TITLE_COLOR["GRAY_700"] = "gray_700";
    EN_TITLE_COLOR["WHITE"] = "white";
    EN_TITLE_COLOR["TRANSPARENCY"] = "transparency";
    EN_TITLE_COLOR["BLUE"] = "blue";
})(EN_TITLE_COLOR = exports.EN_TITLE_COLOR || (exports.EN_TITLE_COLOR = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRU5fVElUTEVfQ09MT1IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvc2FwcG9yby9jb25zdGFudC9lbnVtL3RleHQvRU5fVElUTEVfQ09MT1IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDSCxJQUFZLGNBV1g7QUFYRCxXQUFZLGNBQWM7SUFDeEIsK0JBQWEsQ0FBQTtJQUNiLHFDQUFtQixDQUFBO0lBQ25CLGlDQUFlLENBQUE7SUFDZiwyQ0FBeUIsQ0FBQTtJQUN6QiwyQ0FBeUIsQ0FBQTtJQUN6QiwrQkFBYSxDQUFBO0lBQ2IsdUNBQXFCLENBQUE7SUFDckIsaUNBQWUsQ0FBQTtJQUNmLCtDQUE2QixDQUFBO0lBQzdCLCtCQUFhLENBQUE7QUFDZixDQUFDLEVBWFcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFXekIifQ==